import React from "react";
import {
  FaCartPlus,
  FaBriefcaseMedical,
  FaHeadset,
  FaUserTie,
  FaUtensils,
} from "react-icons/fa6";
import { PiPlugsConnectedFill } from "react-icons/pi";
import { CiImport } from "react-icons/ci";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { GrValidate } from "react-icons/gr";
import NutradSPIcon from "../../assets/img/nt logo smart pipe.png";
import Footer from "../Footer/Footer"
import NutradGDSNIcon from "../../assets/img/nt logo smart gdsn.png";
import GDSNIcon from "../../assets/img/gdsn.png";
import Image from "react-bootstrap/Image";

const GDSN = () => {
  const servicesData = [
    {
      icon: <Image src={GDSNIcon} alt="GDSN" rounded />,
      title: "1WorldSync GDSN Data Pool",
      link: "/import",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "AECOC Data Pool (GS1 Spain) GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Alkemics GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "ANCCNET (GS1 China) GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "atrify GmbH GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "BC Services b synced GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Carrefour Group GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Central Data Bank GS1 Belgilux GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Comarch EDI MDM GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Commport Global Synchronization CGS GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "CONTENTIS AG GloLIB GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Datapool atGP GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "E2open Global Data Pool GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Easy Global Data Pool Attribytes GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "EDICOMDATADP GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "EQUADIS SA GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "EWAY SYNCWAY GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "FSEnet, a Syndigo company GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GHX Health ConneXion GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Global Halal Data Pool / Serunai GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Global Product Exchange Nielsen Brandbank GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GlobeCat GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "FSEnet, a Syndigo company GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Association Greece Hellasync GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Canada GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Colombia LOGYCA COLABORA GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Czech Republic SYNFONY GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 DAS Netherlands GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Denmark GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Finland Synkka GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Hong Kong (GS1CN) GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Iceland Gagnalaug GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Italy datapool GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Mexico Syncfonia GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Portugal GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 Sweden Validoo GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "GS1 UK TrueSource GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "ITN_GDS ItradeNetwork GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "National Product Catalogue GS1 Australia GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Salsify GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "TOBBsenkron GS1 Turkey GDSN Provider",
      link: "/products",
      status: "Available",
    },
    {
      icon: <img src={GDSNIcon} w={50} h={50} alt="GDSN" />,
      title: "Viagenie Global Data Gateway GDSN Provider",
      link: "/products",
      status: "Available",
    },
  ];

  return (
    <div className="py-5">
      <div className="container mx-auto px-4">
        <div className="mb-4">
          <h1 className="h3 fw-semibold mb-2">Available GDSN Pools</h1>
          <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
            To activate a GDSN data pool, please contact nutrād sales -
            <a
              href="mailto:sales@nutrad.io"
              className="text-blue-600 hover:text-blue-800 ml-1"
            >
              sales@nutrad.io
            </a>
          </p>
        </div>

        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {servicesData.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
            >
              <div className="p-4">
                <div className="w-16 mx-auto mb-4">
                  <img
                    src={GDSNIcon}
                    alt="GDSN"
                    className="w-full h-full object-contain rounded-lg"
                  />
                </div>
                <h2 className="text-lg font-semibold text-gray-900 text-center mb-3 line-clamp-2 min-h-[3rem]">
                  {service.title}
                </h2>
                <div className="flex flex-col items-center gap-4">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                    {service.status}
                  </span>
                  <button
                    disabled
                    className="w-full px-4 py-2 text-blue-600 bg-white border border-blue-600 rounded-md transition-colors duration-200 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Request
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default GDSN;
